<template>
  <div class="news">
    <div class="header-bar">
      <div v-on:click="scrollTo('main-nav')" class="logo">
        <img src="./../assets/images/small/logo_s.png" alt />
      </div>
      <router-link to="/">Home</router-link>
    </div>
    <div class="content">
      <section id="contact-us" style="display: flex; align-items: center; justify-content: center;">
        <h1 style="text-align: center; font-size: 24px;">There is no current news to display.</h1>
        <!--<div class="container">
          <div class="text-content-wrapper">
            <h1>Notification of Intent</h1>

            <div class="row">

              <div class="col-md-6 col-lg-6 contact-details">
                <div class="block">
                  <h4>View Notification</h4>
                  <p>
                    <a href="./static/documents/Notification_of_Intent_Zulu.pdf" target="_blank">View in Zulu</a></br>
                    <a href="./static/documents/Notification_of_Intent_English.pdf" target="_blank">View in English</a>
                  </p>
                </div>
              </div>

              <div class="col-md-6 col-lg-6 contact-form">
                <div class="block">
                  <h4>Leave a Comment</h4>
                  <form name="contactForm" v-on:submit="onSubmit">
                    <div class="form-group">
                      <span class="invalid" v-show="errors.has('name')">
                        {{ errors.first('name') }}
                      </span>
                      <label for="name">Name <i class="glyphicon glyphicon-asterisk"></i></label>
                      <input v-model="form.name" type="name" class="form-control" id="name" name="name"
                        placeholder="Enter Your Name" required>
                    </div>

                    <div class="form-group">
                      <span class="invalid" v-show="errors.has('email')">
                        {{ errors.first('email') }}
                      </span>
                      <label for="email">Email Address <i class="glyphicon glyphicon-asterisk"></i></label>
                      <input v-model="form.email" type="email" class="form-control" id="email" name="email"
                        placeholder="Enter Your Email" required>
                    </div>

                    <div class="form-group">
                      <span class="invalid" v-show="errors.has('message')">
                        {{ errors.first('message') }}
                      </span>
                      <label for="email">Message <i class="glyphicon glyphicon-asterisk"></i></label>
                      <textarea v-model="form.message" class="form-control" name="message" rows="3" required></textarea>
                    </div>

                    <div class="recaptcha-section">
                      <div class="recaptcha-wrapper">
                        <vue-recaptcha class="recaptcha" v-bind:sitekey="recaptchaSiteKey" ref="recaptcha"
                          @verify="onVerify" @expired="onExpired"></vue-recaptcha>
                      </div>
                      <div class="recaptcha-privacy-and-terms">
                        reCaptcha
                        <a href="https://www.google.com/intl/en/policies/privacy/" target="_blank">Privacy</a> /
                        <a href="https://www.google.com/intl/en/policies/terms/" target="_blank">Terms</a>
                      </div>
                    </div>
                    <button type="submit" class="submit-button btn btn-lg" :disabled="form.isSending || form.isSent"
                      name="button">
                      <span v-if="!form.isSending && !form.isSent">Send <icon name="paper-plane-o"
                          class="paper-plane-o-icon"></icon></span>
                      <span v-if="form.isSent">Success <icon name="check" class="check-icon"></icon></span>
                      <span v-if="form.isSending">Sending <icon name="ellipsis-h" class="ellipsis-h-icon"></icon></span>
                    </button>
                    <div class="clearfix"></div>
                  </form>
                </div>
              </div>
            </div>
          </div>

        </div>-->
      </section>
    </div>

    <j-footer class="footer"></j-footer>
  </div>
</template>

<script>

import JFooter from '@/components/Footer'
import VueRecaptcha from 'vue-recaptcha'

export default {
  name: 'news',
  created: function () {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    window.gtag('event', 'page', {
      'page': '/news',
      'title': 'News'
    });
  },
  components: { VueRecaptcha, JFooter },
  computed: {
    isValidForm: function () {
      if (!this.form.name) {
        alert("Please enter a Name");
        return false;
      }

      if (!this.form.email) {
        alert("Please enter a valid Email Address");
        return false;
      }

      if (!this.form.message) {
        alert("Please enter a Message");
        return false;
      }

      if (!this.recaptchaKey) {
        alert("Please complete the reCAPTCHA");
        return false;
      }

      return true;
    }
  },
  data() {
    return {
      form: {
        name: '',
        email: '',
        message: '',
        isSending: false,
        isSent: false
      },
      recaptcha: null,
      recaptchaKey: null,
      recaptchaSiteKey: '6LdvJsQeAAAAAONApzSwH0ZGDtIpcqLsWoa4VWG_'
    }
  },
  methods: {
    onVerify: function (response) {
      this.recaptchaKey = response
    },
    onExpired: function () {
      this.recaptchaKey = null
      this.$refs.recaptcha.reset()
    },
    onSubmit: function (e) {
      e.preventDefault();

      if (!this.isValidForm) {
        return
      }

      window.gtag('event', 'click', {
        'event_category': 'notification intent',
        'event_label': 'submit'
      })

      this.form.isSending = true
      this.$http.post('https://comms13th.azurewebsites.net/api/jwayelaniintent', {
        fullName: this.form.name,
        emailAddress: this.form.email,
        message: this.form.message,
        recaptcha: this.recaptchaKey
      })
        .then(
          function (response) {
            // this.$ga.event({eventCategory: 'contact us', eventAction: 'server response', eventLabel: 'sent'})
            this.form.isSent = true
            this.form.isSending = false

            this.form.name = ''
            this.form.email = ''
            this.form.message = ''

            this.$refs.recaptcha.reset()
            this.errors.clear()

            setTimeout(function () {
              this.form.isSent = false
            }.bind(this), 3000)
          },
          function (error) {
            // this.$ga.exception(error)
            this.form.isSending = false
          }
        )
        .then(function () {
          this.errors.clear()
        })
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../scss/colours';
@import '../scss/mixins';

.news {
  .bold {
    font-weight: bold !important;
  }

  .header-bar {
    z-index: 100;
    //position: fixed;
    top: 0;
    width: 100%;
    height: 60px;
    background-color: $red;
    border-bottom: 4px $red-dark solid;

    a {
      float: right;
      color: $yellow;
      font-size: 1.05em;
      line-height: 60px;
      margin-right: 20px;

      &:hover {
        text-decoration: none;
        color: #fff;
      }

      &:active {
        text-decoration: none;
        color: lighten($yellow, 10%);
      }
    }
  }

  .logo {
    display: inline-block;
    text-align: center;
    margin: 1em 20px;

    &:before {
      content: "";
      display: inline-block;
      height: 100%;
      vertical-align: middle;
    }

    img {
      width: 150px;
      vertical-align: middle;
    }
  }

  h1 {
    color: #d51d2f;
    margin-bottom: .5em;
  }

  section {
    min-height: calc(100vh - 60px - 80px);
    padding-top: 2rem;
    padding-bottom: 2rem;
    background-color: $yellow;

    a {
      color: $red-dark;

      &:hover {
        color: $red;
      }
    }
  }

  .submit-button {
    float: right;
    background-color: $red;
    color: white;

    .paper-plane-o-icon {
      margin-left: 10px;
    }

    @include clearfix();
  }

  form {
    label {
      font-weight: bold;
      margin-bottom: 0;
    }

    .form-group {
      position: relative;
    }

    .invalid {
      position: absolute;
      top: 0;
      right: 0;
      padding: 3px 5px 2px;
      border-radius: 3px 3px 0 0;
      color: white;
      font-size: 0.8em;
      background-color: $red-dark;
    }
  }

  .recaptcha-section {
    float: left;
    margin: 0 15px 0 0;
  }

  .recaptcha-wrapper {
    border-radius: 2px;
    position: relative;
    overflow: hidden;
    width: 160px;
    height: 45px;
    overflow: hidden;
    margin: 0;
  }

  .recaptcha {
    position: absolute;
    top: -15px;
    left: -2px;
  }

  .recaptcha-privacy-and-terms {
    font-size: 11px;
    //color: darken($grey-highlight, 30%);
    text-align: center;
    padding-top: 5px;

    a {
      //color: darken($grey-highlight, 15%);
    }
  }

  input {
    padding: 10px 10px 5px;
    border: none;
    border-radius: 0;
    border-bottom: 2px solid $red;
    background-color: lighten($yellow, 25%);

    &::placeholder {
      color: black;
      font-style: italic;
      font-size: 0.9em;
    }
  }

  textarea {
    border: none;
    border-radius: 0;
    border-bottom: 2px solid $red;
    background-color: lighten($yellow, 25%);
  }

}
</style>



// WEBPACK FOOTER //
// src/components/News.vue